import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';
import { formatTodayDate } from './utils';

interface IGetChangeHistoryUrlProps {
  customerId: string;
  accountId: string;
  campaignId?: string;
  startDate: string;
  endDate: string;
  params?: {
    $top: string;
    $count: string;
    $select: string;
    $orderby: string;
  };
}

const ChangeHistoryOdataConfig = {
  $top: '10000',
  $count: 'true',
  $select: 'GroupNumber,ModificationDate,ModifiedByUser,ModifiedByUserId,Tool,CustomerId,AccountId,AccountName,CampaignId,CampaignName,AdvertisingChannelTypeId,AdGroupId,AdGroupName,EntityId,EntityName,AttributeId,AttributeName,ChangeType,MatchTypeId,Undone,ErrorBlobPath,OriginalApplicationId,BlobId,StartOffset,EndOffset',
  $orderby: 'ModificationDate desc',
};

export interface IFetchChangeHistoryDataProps extends IGetChangeHistoryUrlProps {
  ccToken: string;
}

export function getChangeHistoryURL({
  customerId,
  accountId,
  campaignId,
  startDate,
  endDate,
  params = ChangeHistoryOdataConfig,
}: IGetChangeHistoryUrlProps): string {
  const baseUrl = `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})`;
  const campaignPath = campaignId ? `/Campaigns(${campaignId})` : '';
  const queryString = new URLSearchParams({
    ...params,
    startDate,
    endDate,
  });

  return `${baseUrl}${campaignPath}/Default.DimensionReport(Locale=1,ReportType=Enum.DimensionReportType'ChangeHistoryNewSummaryReport')?${queryString}`;
}

export function fetchChangeHistoryData({
  accountId,
  customerId,
  campaignId,
  ccToken,
  startDate = formatTodayDate(),
  endDate = formatTodayDate(),
}: IFetchChangeHistoryDataProps) {
  const url = getChangeHistoryURL({
    customerId, accountId, campaignId, startDate, endDate,
  });

  return axios.get(url, {
    headers: {
      Authorization: ccToken,
    },
  } as AxiosRequestConfig);
}
